import { IonButton } from '@ionic/react';
import styles from './PaginationButton.module.css';

type Props = {
  children: React.ReactNode;
  className?: string;
  isSelected?: boolean;
  onClick: () => void;
};

const PaginationButton: React.FC<Props> = ({ children, className, isSelected, onClick }) => {
  return (
    <IonButton
      onClick={onClick}
      className={`${styles.button} ${isSelected ? styles.selected : ''} ${className || ''}`}
      shape="round"
    >
      {children}
    </IonButton>
  );
};

export default PaginationButton;
